const state = {
	room : null,
	databaseRoom: null,
	autoPrefix: "",
	autoMiddle: 100,
	autoSuffix: "",
	autoMode: false,
	drawingLoading: false,
}

const mutations = {
	setDrawingLoading(state, payload) {
		state.drawingLoading = payload
	},
	mutateAssociationRoom(state, payload) {
		state.room = payload
	},
	setDatabaseRoom(state, payload) {
		state.databaseRoom = payload
	},
	setAutoMode(state, payload) {
		state.autoMode = payload
	},
	setAutoPrefix(state, payload) {
		state.autoPrefix = payload
	},
	setAutoMiddle(state, payload) {
		state.autoMiddle = payload
	},
	setAutoSuffix(state, payload) {
		state.autoSuffix = payload
	},
	updateRoom(state, payload) {
		state.room = payload
		console.log(state.room)
	},
	incrementAuto(state) {
		state.databaseRoom.number = state.autoPrefix + state.autoMiddle + state.autoSuffix
		
		if (state.autoSuffix) {
			if (state.autoSuffix=="Z")	{
				state.autoSuffix= "ZA"
				return
			}
			console.log(state.autoSuffix.slice(0,1))
			let firstChar = state.autoSuffix.slice(0,1)
			let secondChar = state.autoSuffix.slice(1,2)
			if (secondChar) { state.autoSuffix = firstChar + nextChar(secondChar) }
			else { state.autoSuffix = nextChar(state.autoSuffix) }
		} else {
			state.autoMiddle = parseInt(state.autoMiddle) + 1
		}



		function nextChar(c) {
		    return String.fromCharCode(c.charCodeAt(0) + 1);
		}

	},
}

const actions = {
	setAssociationRoom({commit, state, rootState}, payload) {
		//console.log("setAssociationRoom")
		return new Promise((resolve, reject) => {
			if (payload) {
						let prefix = "R_Level_" + rootState.ui.currentFloor + "."
						let room = {}
						room.Join_Key = payload['Join_Key'] || payload[prefix + 'Join_Key']
						room.ehandle = payload['Handle'] || payload[prefix + 'Handle']
						room.dwgName = payload['DocName'] || payload[prefix + 'DocName']
						//room.areaCAD = Math.round((payload['Shape_Area'] || payload[prefix + 'Shape_Area']) / 144 )
						//room.areaCAD = payload['Shape_Area']
						
						//console.log(payload['Shape_Area'])
						// Not sure what the significance of 18.24 is, but after importing CAD and projecting to webmercator, this is the conversion factor for area thats needed.
						room.areaCAD = Math.round((payload['Shape_Area'] || payload[prefix + 'Shape_Area']) / 18.24369 )
						room.roomKey = payload['ROOMEXT.roomKey'] || payload[prefix + 'ROOMEXT.roomKey']
						
						commit('mutateAssociationRoom', room)
						resolve()

			} else { 	commit('mutateAssociationRoom', null)
						resolve()
			}
		})
	},

	newRoomAutoSave({dispatch, commit, state, rootState}) {
		return new Promise((resolve, reject) => {
			const prevautoPrefix 	= state.autoPrefix
			const prevautoMiddle 	= state.autoMiddle
			const prevautoSuffix 	= state.autoSuffix

			commit('incrementAuto')
			this.dispatch('associateRoom')
			.then(() => {
				this.dispatch('saveRoom', state.databaseRoom)
				.then((response) => { 
					if (response != "Saved") { 
						commit('setSnackText', response) 
						state.autoPrefix = prevautoPrefix
						state.autoMiddle = prevautoMiddle
						state.autoSuffix = prevautoSuffix
					} else {
						dispatch('symbolizeNullFeatureLayer', state.databaseRoom.bldgAlpha)
					}
					resolve()
				})
			})			
		})
	},

	associateRoom({commit, state, rootState}, payload) {
		return new Promise((resolve, reject) => {
		if (state.databaseRoom && state.room ) {
			let room = { ...state.databaseRoom }

			if (payload=='ehandle') { room.ehandle = state.room.ehandle 
									 room.dwgName = state.room.dwgName.split(".")[0] }

			if (payload=='area') { room.areaCAD = state.room.areaCAD }

			// Do both is no payload.  This is for autoroom feature
			if (!payload) { room.ehandle = state.room.ehandle 
							room.dwgName = state.room.dwgName.split(".")[0] 
							room.areaCAD = state.room.areaCAD }
			
			// This changes the graphic layer.  Not sure if I want to keep this.  Used to symbolize
			state.room.Room_Key = room.bldgAlpha + "+" + room.number
			//console.log("Room Graphic", state.room)
			commit('setDatabaseRoom', room)			
			resolve()
		}
	})

	},

}

export default {
	state,
	//getters,
	actions,
	mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/association.js